const linkGenerator = (link, file, params) => {
  var pramsText = ''
  if (typeof params === 'object') {
    var str = []
    for (var p in params) {
      if (params.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]))
      }
    }
    pramsText = '&' + str.join('&')
  }

  return file
    ? localStorage.getItem('site') + link + localStorage.getItem('auth') + pramsText
    : localStorage.getItem('site') + '/api' + link + localStorage.getItem('auth') + pramsText
}

export default linkGenerator
